import React from 'react';
import { Box } from '@mui/material';
import Container from 'components/Container';
import Carousel from '../Carousel';
import { HeroCarouselItem } from 'Pages/Main/cmsTypes';

interface HeroProps {
  backgroundUrl?: string;
  items?: HeroCarouselItem[];
}

const Hero = ({ backgroundUrl, items }: HeroProps) => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${backgroundUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        height: '800px',
      }}
    >
      <Container>
        {items?.length ? (
          <Carousel items={items} />
        ) : (
          <Box component="span" sx={{ display: 'block', height: 0 }} aria-hidden />
        )}
      </Container>
    </Box>
  );
};

export default Hero;
